// import {useCallback, useState} from "react";
// import useStore from "./useStore";
//
// interface UsePostReturn{
//     loading: boolean;
//     error: any;
//     post: (url: string,json:boolean, body: any,edit?:boolean) => Promise<void>;
// }
//
// const usePost = (): UsePostReturn => {
//     const {accessToken} = useStore()
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState<any>(null);
//
//
//     const request = useCallback(
//         async (url: string, options: RequestInit) => {
//             setLoading(true);
//             setError(null);
//
//             try {
//                 const res = await fetch(url, options);
//                 const result = await res.json();
//
//                 if (!res.ok) {
//                     throw result;
//                 }
//                 return result;
//             } catch (err) {
//                 setError(err);
//             } finally {
//                 setLoading(false);
//             }
//         },
//         []
//     );
//
//
//     const post = async (url: string,json:any, body: any,edit=false) => {
//         const headers:any = {
//             'Authorization': `Bearer ${accessToken}`
//         }
//         if (json) {
//             headers['Content-Type'] = 'application/json';
//         }
//         return request(url, {
//             method: edit ? "PUT" : "POST",
//             headers: headers,
//             body: body,
//         });
//     };
//
//     return { loading, error,post };
// };
//
// export default usePost;

import { useCallback, useState } from "react";
import useStore from "./useStore";

interface ApiResponse {
    success: boolean;
    data?: any;
    error?: any;
}

interface UsePostReturn {
    loading: boolean;
    error: any;
    post: (url: string, json: boolean, body: any, edit?: boolean) => Promise<ApiResponse>;
}

const usePost = (): UsePostReturn => {
    const { accessToken } = useStore();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<any>(null);

    const request = useCallback(
        async (url: string, options: RequestInit): Promise<ApiResponse> => {
            setLoading(true);
            setError(null);

            try {
                const res = await fetch(url, options);
                let result: any = null;
                try {
                    result = await res.json();
                } catch {
                    result = null;
                }

                if (!res.ok) {
                    setError(result);
                    return {
                        success: false,
                        error: result,
                    };
                }

                return {
                    success: true,
                    data: result,
                };

            } catch (err) {
                setError(err);

                return {
                    success: false,
                    error: err,
                };

            } finally {
                setLoading(false);
            }
        },
        []
    );

    const post = async (
        url: string,
        json: boolean,
        body: any,
        edit = false
    ): Promise<ApiResponse> => {

        const headers: any = {
            Authorization: `Bearer ${accessToken}`,
        };

        if (json) {
            headers["Content-Type"] = "application/json";
        }

        return request(url, {
            method: edit ? "PUT" : "POST",
            headers,
            body: json ? JSON.stringify(body) : body,
        });
    };

    return { loading, error, post };
};

export default usePost;